import { ACCOUNT_ID_FOR_EXTENDED_TESTS, GRAFANA_UPTIME_URL, KIBANA_URL } from 'environment';
import './new_extended_test_controller';

angular
.module('app.views')
.config(($routeProvider) => {
      $routeProvider.when('/extended_tests', {
          template: require('./extended_tests.html'),
          controller: 'ExtendedTestsController'
      });
})
.controller('ExtendedTestsController', function($scope, $location, $modal, $timeout, $q, Broadcast){
  // How long in the past should we look for recent extended tests
  const RECENT_TIME_HORIZON_MS = 1 * 24 * 60 * 60 * 1000; // 1 day

  // How often to reload current and recent extended tests
  const RELOAD_INTERVAL_MS = 60 * 1000;

  // This set of functions deals with reloading current and recent extended tests.
  let timeoutId = null;
  const cancelTimeout = function() {
    if (timeoutId != null) {
      $timeout.cancel(timeoutId);
      return timeoutId = null;
    }
  };
  const reload = function() {
    cancelTimeout();
    var b1 = Broadcast.query({
      'filter.account_id': ACCOUNT_ID_FOR_EXTENDED_TESTS,
      'filter.include_archived': 'false',
      q: `timeframe:current timeframe:preroll timeframe:future +*extended*`
    }, data => {
      $scope.current_extended_tests = data
    });
    const to = new Date();
    const from = new Date(to.getTime() - RECENT_TIME_HORIZON_MS);
    // XXX: This can be a dreadfully slow query, see PLATFORM-147
    var b2 = Broadcast.query({
      'filter.account_id': ACCOUNT_ID_FOR_EXTENDED_TESTS,
      'filter.include_archived': 'false',
      q: `timeframe:past +stops_at:[${from.toISOString()} TO ${to.toISOString()}] +*extended*`,
      s: '-starts_at'
    }, data => {
      $scope.recent_extended_tests = data
    });
    $q.all([b1.$promise, b2.$promise]).then(() => {
      timeoutId = $timeout(reload, RELOAD_INTERVAL_MS);
    })
  };
  reload();
  $scope.$on('$destroy', cancelTimeout);

  // Provide a URL for a graphite graph that shows the BoxCaster's uptime for the duration of the test.
  $scope.uptimeUrl = function(broadcast){
    if (!broadcast.__grafana_url) {
      // XXX: Date.now() in URL would cause Angular to freak out during digest loop
      const starts_at = (new Date(Date.parse(broadcast.starts_at))).getTime();
      const stops_at = (new Date(Date.parse(broadcast.stops_at))).getTime();
      broadcast.__grafana_url = `${GRAFANA_UPTIME_URL}?var-boxcaster_id=${broadcast.boxcaster_id}&from=${starts_at}&to=${stops_at}`;
    }
    return broadcast.__grafana_url;
  };

  // Provide a URL for a kibana dashbaord that shows link up/down events for the BoxCaster for the
  // duration of the test.
  $scope.boxcasterLinkUrl = function(broadcast){
    const from = new Date(Date.parse(broadcast.starts_at));
    const to = new Date(Date.parse(broadcast.stops_at));
    return `${KIBANA_URL}/app/kibana#/discover?_g=(refreshInterval:(display:Off,pause:!f,section:0,value:0),time:(from:'${from.toISOString()}',mode:absolute,to:'${to.toISOString()}'))&_a=(columns:!(tag,level,message),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'logs-*',key:hostname,negate:!f,value:${broadcast.boxcaster_id}),query:(match:(hostname:(query:${broadcast.boxcaster_id},type:phrase))))),index:'logs-*',interval:auto,query:(query_string:(analyze_wildcard:!t,query:'message:%22Link%20is%22')),sort:!('@timestamp',desc))`;
  };

  // Create a new set of extended tests via the modal window.
  $scope.create = () =>
    $modal.open({template: require('./new_extended_test_form.html'), controller: 'NewExtendedTestController', size: 'lg', backdrop: 'static'}).result.then(() => reload())
  ;

  // Show an extended test's broadcast (admin) page.
  $scope.show = broadcast=> $location.url(`/broadcasts/${broadcast.id}`);

  // Stop an extended test by setting its stops_at to now.
  $scope.stop = function(broadcast){
    if (confirm('Are you sure you want to stop this broadcast?')) {
      return Broadcast.update({id: broadcast.id}, {stops_at: (new Date()).toISOString()}, () => reload());
    }
  };

  // Delete an extended test.
  return $scope.delete = function(broadcast){
    if (confirm('Are you sure you want to delete this broadcast?')) {
      return Broadcast.delete({id: broadcast.id}, () => reload());
    }
  };
});



// WEBPACK FOOTER //
// ./views/extended_tests/extended_tests_controller.js